import { RouteManagementTab, RouteSubTab } from '../types';
import Icons from '../../../components/icons';

export const RouteManagementTabConfig = [
  {
    id: RouteManagementTab.ROUTES,
    label: 'Routes',
    selectedIcon: Icons.DrivingWhite,
    unselectedIcon: Icons.DrivingBlack
  },
  {
    id: RouteManagementTab.STOPS,
    label: 'Stops',
    selectedIcon: Icons.RoutingWhite,
    unselectedIcon: Icons.RoutingBlack
  }
];

export const RouteTabConfig = [
  {
    id: RouteSubTab.All,
    label: 'All',
    selectedIcon: Icons.Arrow3Filled,
    unselectedIcon: Icons.Arrow3Black
  },
  {
    id: RouteSubTab.PICK_UP_ROUTES,
    label: 'Pick up routes',
    selectedIcon: Icons.ArrowUpFilled,
    unselectedIcon: Icons.ArrowUpBlack
  },
  {
    id: RouteSubTab.DROP_OFF_ROUTES,
    label: 'Drop off routes',
    selectedIcon: Icons.ArrowDownFilled,
    unselectedIcon: Icons.ArrowDownBlack
  }
];
